import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SproutIcon, MenuIcon, XIcon, Search, Bell } from 'lucide-react';
import { NotificationSystem } from '../Notifications/NotificationSystem';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const location = useLocation();
  const navItems = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Projects',
    path: '/projects'
  }, {
    name: 'Discover',
    path: '/discover'
  }, {
    name: 'Deals',
    path: '/deals'
  }, {
    name: 'Progress',
    path: '/progress'
  }, {
    name: 'Repayments',
    path: '/repayments'
  }];
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  return <header className="bg-white shadow-sm sticky top-0 z-40" data-id="element-322">
      <div className="container mx-auto px-4 py-3" data-id="element-323">
        <div className="flex items-center justify-between" data-id="element-324">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-325">
            <div className="bg-leaf-green rounded-full p-1 mr-2" data-id="element-326">
              <SproutIcon size={24} className="text-white" data-id="element-327" />
            </div>
            <span className="text-xl font-montserrat font-bold text-soil-brown" data-id="element-328">
              GrowConnect
            </span>
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6" data-id="element-329">
            {navItems.map(item => <Link key={item.path} to={item.path} className={`font-medium ${location.pathname === item.path ? 'text-leaf-green border-b-2 border-leaf-green' : 'text-gray-600 hover:text-leaf-green'}`} data-id="element-330">
                {item.name}
              </Link>)}
          </nav>
          {/* Desktop Action Items */}
          <div className="hidden md:flex items-center space-x-2" data-id="element-331">
            {/* Search Button */}
            <div className="relative" data-id="element-332">
              <button onClick={() => setIsSearchOpen(!isSearchOpen)} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Search" data-id="element-333">
                <Search size={20} className="text-gray-700" data-id="element-334" />
              </button>
              {/* Search Popup */}
              {isSearchOpen && <div className="absolute right-0 mt-2 w-72 bg-white rounded-lg shadow-lg p-3 z-50" data-id="element-335">
                  <div className="relative" data-id="element-336">
                    <input type="text" placeholder="Search GrowConnect..." className="input-field pl-9 pr-4 py-2" autoFocus data-id="element-337" />
                    <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-338" />
                  </div>
                  <div className="mt-2 text-xs text-gray-500" data-id="element-339">
                    <p data-id="element-340">Try searching for projects, investors, or crops</p>
                  </div>
                </div>}
            </div>
            {/* Notifications */}
            <NotificationSystem data-id="element-341" />
            <Link to="/onboarding" className="btn btn-primary" data-id="element-342">
              Sign In
            </Link>
          </div>
          {/* Mobile Menu Button */}
          <div className="flex items-center space-x-2 md:hidden" data-id="element-343">
            <button onClick={() => setIsSearchOpen(!isSearchOpen)} className="p-2 rounded-full hover:bg-gray-100" aria-label="Search" data-id="element-344">
              <Search size={20} className="text-gray-700" data-id="element-345" />
            </button>
            <NotificationSystem data-id="element-346" />
            <button className="text-gray-600 focus:outline-none" onClick={toggleMenu} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-347">
              {isMenuOpen ? <XIcon size={24} data-id="element-348" /> : <MenuIcon size={24} data-id="element-349" />}
            </button>
          </div>
        </div>
        {/* Mobile Search */}
        {isSearchOpen && <div className="mt-3 pb-2 md:hidden" data-id="element-350">
            <div className="relative" data-id="element-351">
              <input type="text" placeholder="Search GrowConnect..." className="input-field pl-9 pr-4 py-2 w-full" autoFocus data-id="element-352" />
              <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-353" />
            </div>
          </div>}
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden py-4" data-id="element-354">
            <div className="flex flex-col space-y-3" data-id="element-355">
              {navItems.map(item => <Link key={item.path} to={item.path} className={`py-2 px-3 rounded-md font-medium ${location.pathname === item.path ? 'bg-leaf-green/10 text-leaf-green' : 'text-gray-600 hover:bg-gray-100'}`} onClick={toggleMenu} data-id="element-356">
                  {item.name}
                </Link>)}
              <Link to="/onboarding" className="btn btn-primary mt-2" onClick={toggleMenu} data-id="element-357">
                Sign In
              </Link>
            </div>
          </div>}
      </div>
    </header>;
};